export const categories = [
  {
    key: 'corrective',
    label: 'Corrective',
  },
  {
    key: 'preventive',
    label: 'Preventive',
  },
  {
    key: 'onboarding',
    label: 'Onboarding',
  },
  {
    key: 'offboarding',
    label: 'Offboarding',
  },
];

export const types = [
  {
    key: 'inspection',
    label: 'Inspection',
  },
  {
    key: 'repair',
    label: 'Repair',
  },
  {
    key: 'maintenance',
    label: 'Maintenance',
  },
];

export const priorities = [
  {
    key: 1,
    label: 'Very Low',
  },
  {
    key: 2,
    label: 'Low',
  },
  {
    key: 3,
    label: 'Medium',
  },
  {
    key: 4,
    label: 'High',
  },
  {
    key: 5,
    label: 'Critical',
  },
];

export const impacts = [
  {
    key: 1,
    label: 'High',
  },
  {
    key: 2,
    label: 'Medium',
  },
  {
    key: 3,
    label: 'Low',
  },
];

export const executionIntervalValues = {
  daily: '1-day',
  weekly: '1-week',
  monthly: '1-month',
  quarter: '3-months',
  semiAnnual: '6-months',
  threeQuarter: '9-months',
  annual: '12-months',
  na: 'na',
} as const;

export const executionIntervals = [
  {
    key: executionIntervalValues.daily,
    label: 'Daily',
  },
  {
    key: executionIntervalValues.weekly,
    label: 'Weekly',
  },
  {
    key: executionIntervalValues.monthly,
    label: 'Monthly',
  },
  {
    key: executionIntervalValues.quarter,
    label: '3 months',
  },
  {
    key: executionIntervalValues.semiAnnual,
    label: '6 months',
  },
  {
    key: executionIntervalValues.threeQuarter,
    label: '9 months',
  },
  {
    key: executionIntervalValues.annual,
    label: '12 months',
  },
  {
    key: executionIntervalValues.na,
    label: 'N/A',
  },
];

export const BLANK_TEXT = 'blank';
